<template>
  <div class="view">
    <Title title="メッセージ"/>
    <MessageNewMain />
  </div>
</template>

<script>
import Title from '@/components/Title.vue'
import MessageNewMain from '@/components/Message/NewMain'

export default {
  components: {
    Title,
    MessageNewMain
  }
}
</script>
